const Index = () => import('@/modules/subscriptions/index');

export default [
    {
        path: '/subscriptions',
        name: 'subscriptions',
        meta: {
            // layout: window.isWebView ? 'empty' : 'main',
            layout: 'empty',
            page: 'subscriptions',
            title: 'Тарифы',
            headerTitle: 'Тарифы',
        },
        component: Index,
    },
];
